module.exports = __webpack_public_path__ + "img/header-diamondJewelry050Carat.ad359cd.webp";